(function () {
  function init(root) {
    if (root.dataset.ssPgmInit === 'true') return;
    root.dataset.ssPgmInit = 'true';

    const lightbox = root.querySelector('[data-ss-pgm-lightbox]');
    const scroller = root.querySelector('[data-ss-pgm-scroller]');
    const closeBtn = root.querySelector('[data-ss-pgm-close]');
    const openers = root.querySelectorAll('[data-ss-pgm-open]');

    if (!lightbox || !scroller) return;

    let lastFocused = null;

    function open(index) {
      lastFocused = document.activeElement;
      lightbox.hidden = false;
      // Force reflow so the transition plays
      void lightbox.offsetWidth;
      lightbox.setAttribute('data-open', 'true');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ss-pgm-open');

      const target = scroller.querySelector('[data-index="' + index + '"]');
      if (target) {
        // Jump without animation on open
        scroller.scrollTo({ top: target.offsetTop, behavior: 'auto' });
      } else {
        scroller.scrollTop = 0;
      }

      document.addEventListener('keydown', onKeydown);
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      lightbox.removeAttribute('data-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ss-pgm-open');
      document.removeEventListener('keydown', onKeydown);

      const onEnd = () => {
        lightbox.hidden = true;
        lightbox.removeEventListener('transitionend', onEnd);
      };
      lightbox.addEventListener('transitionend', onEnd);

      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    function onKeydown(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        close();
      }
    }

    openers.forEach((btn) => {
      btn.addEventListener('click', () => {
        const idx = parseInt(btn.getAttribute('data-index') || '0', 10);
        open(isNaN(idx) ? 0 : idx);
      });
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', close);
    }

    // Click outside images (on scroller background) closes
    scroller.addEventListener('click', (e) => {
      if (e.target === scroller) close();
    });
  }

  function boot() {
    document.querySelectorAll('[data-ss-pgm]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('[data-ss-pgm]');
    if (section) init(section);
  });
})();
